<template>
<div>
    <modal-layout v-if="isDisclaimerModalVisible">
        <div class="disclaimer">
            <h3 class="disclaimer__title"> {{ $t('disclaimer_title') }}</h3>
            <div class="disclaimer__info"> {{ $t('disclaimer_info') }} {{ $t('disclaimer_info_two') }} </div>
            <ui-button @click="closeModalAlert" style="margin-right:20px" class="btn--primary">{{ $t('disclaimer_ok_btn') }}</ui-button>
            <ui-anchor-button href="https://aurabiosciences.com/" class="abtn--text">{{ $t('disclaimer_close_btn') }}</ui-anchor-button>
        </div>
    </modal-layout>
    <site-menu @localeHasChangedEvent="reloadSections"></site-menu>
    <!--
    <section id="ui_sh_v3" class="ui-sh-v3-wrapper">
        <div class="width-limit">
            <div class="ui-sh-v3-flex">
                <div class="ui-sh-image-wrap">
                    <span class="fa-stack fa-lg fa-2x">
                        <i class="ui-nb-circle fa fa-circle fa-stack-2x"></i>
                        <i class="ui-nb-icon fa fa-bullhorn fa-stack-1x fa-inverse"></i>
                    </span>
                </div>
                <div class="ui-sh-text-wrap">
                    <h2 id="head" class="ui-sh-v3-heading">{{ $t('disclaimer_title') }}</h2>
                    <p id="subhead" class="ui-sh-v3-para">{{ $t('disclaimer_info') }}</p>
                </div>
            </div>
        </div>
    </section>
-->
    <site-banner id="js-home"></site-banner>
    <about-study id="js-about"></about-study>
    <study-info></study-info>
    <study-center-map id="js-center" :key="mapKey"></study-center-map>
    <timeline-section id="js-timeline"></timeline-section>
    <bel-sar-admin id="js-bel-sar"></bel-sar-admin>
    <uv-precautions id="js-uv"></uv-precautions>
    <eligibility-section id="js-eligible" :key="eligSecKey"></eligibility-section>
    <faq-section id="js-faqs"></faq-section>
    <share-study id="js-share"></share-study>
    <ui-footer />
    <copyright-label class="copyright" :locale="$i18n.locale"></copyright-label>
</div>
</template>

<script>
import UiMenuVue from './partials/SiteMenu.vue'
import EligibilityVue from './partials/Eligibility.vue'
import FaqSectionVue from './partials/FaqSection.vue'
import StudyInfoVue from './partials/StudyInfo.vue'
import StudyCenterVue from './partials/StudyCenter.vue'
import TimelineSectionVue from './partials/TimelineSection.vue'
import SiteBannerVue from './partials/SiteBanner.vue'
import AboutStudyVue from './partials/AboutStudy.vue'
import ShareStudyVue from './partials/ShareStudy.vue'
import CopyRightLabelVue from '../components/CopyRightLabel.vue'
import FooterVue from './partials/Footer.vue'
import BelSarAdminVue from './partials/BelSarAdmin.vue'
import UvPrecautionsVue from './partials/UvPrecautions.vue'
import ModalLayout from '../components/layout/ModalLayout.vue'
import UiButton from '../components/UiButton.vue'
import UiAnchorButton from '../components/UiAnchorButton.vue'

export default {

    components: {
        "eligibility-section": EligibilityVue,
        "study-center-map": StudyCenterVue,
        "site-menu": UiMenuVue,
        "site-banner": SiteBannerVue,
        "bel-sar-admin": BelSarAdminVue,
        "uv-precautions": UvPrecautionsVue,
        "faq-section": FaqSectionVue,
        "timeline-section": TimelineSectionVue,
        "study-info": StudyInfoVue,
        "about-study": AboutStudyVue,
        "share-study": ShareStudyVue,
        "copyright-label": CopyRightLabelVue,
        "ui-footer": FooterVue,
        "modal-layout": ModalLayout,
        UiButton,
        UiAnchorButton
    },
    data() {
        return {
            mapKey: "hgjjf",
            eligSecKey: "bklof",
            isDisclaimerModalVisible: true,
            showAlert: true
        }
    },
    mounted() {
        document.title = this.$t('site_title');
    },

    methods: {
        hideAlert() {
            this.showAlert = false;
        },
        reloadMap() {
            this.mapKey = this.mapKey + new Date().getSeconds();
        },

        reloadEligibilitySection() {
            this.eligSecKey = this.eligSecKey + new Date().getSeconds();
        },
        reloadSections() {
            this.reloadMap();
            this.reloadEligibilitySection()
        },
        closeModalAlert() {
            this.isDisclaimerModalVisible = false;
            document.body.style.overflow = "auto";
        }
    },

}
</script>

<style lang="scss">
.copyright {
    padding: 16px;
    //background: #4E5157;
    color: white;
    text-align: center;
}

.home .ui-modal {
    align-items: flex-start;
    justify-content: center;
}

body {
    overflow: hidden;
}

.disclaimer {
    background-color: white;
    width: 700px;
    margin-top: 32px;
    padding: 32px;
    font-size: 20px;
    line-height: 1.5;
    border-radius: 2px;

    &__title {
        color: $accent-color;
        border-bottom: 1px solid #eaeaea;
    }

    &__info {
        max-width: 600px;
        font-size: 16px;
        margin-top: 24px;
        margin-bottom: 52px;
    }
}


</style>
